var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"public-slogan"},[_c('p',[_vm._v(_vm._s(_vm.$t('Index.pages1.title'))),_c('br'),_vm._v("Where Your Goals Begin")])])
}
var staticRenderFns = []

export { render, staticRenderFns }